export const AI_AGENTS_MAX_FORM_LIMIT = {
  name: 256,
};
